module.exports = __webpack_public_path__ + "static/media/mb3.6bc8c436.png";